/*!
 * 大規模修繕ページ専用スクリプト
 * page-renovation.php で使用
 * ビルドで assets/js/renovation.js に出力される
 */
(function ($) {
	'use strict';

	$(function () {
		initFaqAccordion();
		initMenuItemAccordion();
		initMenuTabs();
		initStrengthTabs();
	});

	/**
	 * FAQ アコーディオン
	 * aria-expanded と hidden 属性の切り替えで開閉。
	 */
	function initFaqAccordion() {
		$('.m-faq-item__button').on('click', function () {
			var $btn = $(this);
			var expanded = $btn.attr('aria-expanded') === 'true';
			var panelId = $btn.attr('aria-controls');
			var $panel = $('#' + panelId);

			$btn.attr('aria-expanded', expanded ? 'false' : 'true');
			$panel.prop('hidden', expanded);
		});
	}

	/**
	 * リフォームメニューのアコーディオン
	 * CTA ボタンで工事内容リスト（.m-menu-item__checks）を開閉する。
	 */
	function initMenuItemAccordion() {
		$('.m-menu-item__cta').on('click', function () {
			var $btn = $(this);
			var expanded = $btn.attr('aria-expanded') === 'true';
			var panelId = $btn.attr('aria-controls');
			var $panel = $('#' + panelId);

			$btn.attr('aria-expanded', expanded ? 'false' : 'true');
			$panel.prop('hidden', expanded);
		});
	}

	/**
	 * menu セクションのタブ切り替え
	 * バッジ（.js-menu-tab）クリックで対応する .js-menu-panel を表示する。
	 */
	function initMenuTabs() {
		var $tabs = $('.js-menu-tabs .js-menu-tab');
		if (!$tabs.length) return;

		$tabs.on('click', function () {
			var $btn = $(this);
			if ($btn.attr('aria-selected') === 'true') return;

			var target = $btn.data('tab-target');
			var $section = $btn.closest('.m-menu');

			$section.find('.js-menu-tab').each(function () {
				var $tab = $(this);
				var isActive = $tab.data('tab-target') === target;
				$tab
					.attr('aria-selected', isActive ? 'true' : 'false')
					.toggleClass('m-menu__badge--active', isActive);
			});

			$section.find('.js-menu-panel').each(function () {
				var $panel = $(this);
				var isActive = $panel.attr('id') === 'menu-panel-' + target;
				$panel.prop('hidden', !isActive);
			});
		});
	}

	/**
	 * strength セクションのタブ切り替え
	 * data-tab-target とパネル id で紐付け、is-active と hidden 属性で表示を切り替える。
	 */
	function initStrengthTabs() {
		var $tabs = $('.js-strength-tabs .js-tab-nav-item');
		if (!$tabs.length) return;

		$tabs.on('click', function () {
			var $btn = $(this);
			if ($btn.hasClass('is-active')) return;

			var target = $btn.data('tab-target');
			var $group = $btn.closest('.m-strength');

			$group.find('.js-tab-nav-item').each(function () {
				var isActive = $(this).data('tab-target') === target;
				$(this)
					.toggleClass('is-active', isActive)
					.attr('aria-selected', isActive ? 'true' : 'false');
			});

			$group.find('.js-tab-panel').each(function () {
				var $panel = $(this);
				var isActive = $panel.attr('id') === 'strength-panel-' + target;
				$panel.toggleClass('is-active', isActive).prop('hidden', !isActive);
			});
		});
	}

})(jQuery);
